import(/* webpackMode: "eager" */ "/var/www/saajRiwaajFrontend/src/app/(user)/delivery-information/page.js");
